import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileCategoryOpen, setMobileCategoryOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
    setMobileCategoryOpen(false);
  };

  const toggleMobileCategory = () => {
    setMobileCategoryOpen(!mobileCategoryOpen);
  };

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md'
          : 'bg-transparent'
      }`}
    >
      <div className="flex items-center justify-between h-[72px] px-8 md:px-12 lg:px-16">
        <Link to="/" className="flex items-center gap-1">
          <span className="font-heading text-xl font-bold text-foreground-950">
            YOYBUY Spreadsheet
          </span>
          <span className="w-1.5 h-1.5 rounded-full bg-primary-500"></span>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          <a href="#compare" className="text-sm text-foreground-700 hover:text-foreground-950 transition-colors whitespace-nowrap">
            Сравнение
          </a>
          <a href="#categories" className="text-sm text-foreground-700 hover:text-foreground-950 transition-colors whitespace-nowrap">
            Категории
          </a>
          <Link to="/blog/yoybuy-spreadsheet-polnoe-rukovodstvo" className="text-sm text-foreground-700 hover:text-foreground-950 transition-colors whitespace-nowrap">
            Статьи
          </Link>
          <a href="#faq" className="text-sm text-foreground-700 hover:text-foreground-950 transition-colors whitespace-nowrap">
            FAQ
          </a>
        </div>

        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="hidden md:inline-flex items-center gap-2 px-4 py-2 rounded-full border border-foreground-300 text-sm text-foreground-800 hover:bg-foreground-950 hover:text-background-50 hover:border-foreground-950 transition-all duration-200 whitespace-nowrap cursor-pointer"
        >
          <i className="ri-shopping-cart-line text-base"></i>
          yoybuy sheet
        </a>

        <button
          className="md:hidden flex items-center justify-center w-10 h-10 text-foreground-950"
          onClick={toggleMobileMenu}
        >
          <i className={`text-2xl ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 px-6 py-4 flex flex-col gap-1 max-h-[70vh] overflow-y-auto">
          <a
            href="#compare"
            className="text-sm text-foreground-700 hover:text-foreground-950 py-2.5 px-2 rounded-lg hover:bg-background-100 transition-colors"
            onClick={() => setMobileMenuOpen(false)}
          >
            Сравнение
          </a>

          <button
            onClick={toggleMobileCategory}
            className="w-full flex items-center justify-between text-sm text-foreground-700 hover:text-foreground-950 py-2.5 px-2 rounded-lg hover:bg-background-100 transition-colors cursor-pointer"
          >
            <span>Категории</span>
            <i className={`ri-arrow-down-s-line text-base transition-transform duration-200 ${mobileCategoryOpen ? 'rotate-180' : ''}`}></i>
          </button>

          {mobileCategoryOpen && (
            <div className="flex flex-col gap-0.5 pl-4 border-l-2 border-primary-200/50 ml-2">
              {categories.map((cat, idx) => (
                <a
                  key={idx}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-600 hover:text-foreground-950 py-2 px-2 rounded-lg hover:bg-background-100 transition-colors whitespace-nowrap"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {cat.name}
                </a>
              ))}
            </div>
          )}

          <Link
            to="/blog/yoybuy-spreadsheet-polnoe-rukovodstvo"
            className="text-sm text-foreground-700 hover:text-foreground-950 py-2.5 px-2 rounded-lg hover:bg-background-100 transition-colors"
            onClick={() => setMobileMenuOpen(false)}
          >
            Статьи
          </Link>
          <a
            href="#faq"
            className="text-sm text-foreground-700 hover:text-foreground-950 py-2.5 px-2 rounded-lg hover:bg-background-100 transition-colors"
            onClick={() => setMobileMenuOpen(false)}
          >
            FAQ
          </a>

          <div className="border-t border-background-200 my-2"></div>

          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 py-2.5 px-2 rounded-lg hover:bg-primary-50 transition-colors whitespace-nowrap"
            onClick={() => setMobileMenuOpen(false)}
          >
            <i className="ri-shopping-cart-line text-base"></i>
            yoybuy sheet
          </a>

          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center justify-center gap-2 bg-primary-500 text-background-50 rounded-full py-2.5 px-6 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap mt-1"
            onClick={() => setMobileMenuOpen(false)}
          >
            buy it now
          </a>
        </div>
      )}
    </nav>
  );
}